import { Text } from '@/components/ui/text'
import { api } from '@api'
import { useQuery } from '@tanstack/solid-query'
import { Bookmark } from 'lucide-solid'
import { Show } from 'solid-js'
import { Flex } from 'styled-system/jsx'

// The PHQ and community scores both come from setup_enriched
async function fetchSetupScores(setupId: string) {
  const { data, error } = await api()
    .from('setup_enriched')
    .select('commander_score, community_score, community_scores_count')
    .eq('id', setupId)
    .maybeSingle()

  if (error) throw error

  return data
}

export const useSetupScores = (setupId: () => string | undefined) =>
  useQuery(() => ({
    queryKey: ['setup-scores', setupId()],
    queryFn: () => fetchSetupScores(setupId() || ''), // Safely handle TS error
    enabled: !!setupId(),
    staleTime: 30 * 60 * 1000, // 30m cache freshness
    gcTime: 30 * 60 * 1000, // 30m cache retention
    retry: 1,
  }))

export const CommanderScore = (props: { setupId?: string }) => {
  const q = useSetupScores(() => props.setupId)

  const score = () => {
    const val = q.data?.commander_score ?? 0
    return Number.isInteger(val) ? val : val.toFixed(1)
  }

  return (
    <Show
      when={(q.data?.commander_score ?? 0) > 0}
      fallback={<Text fontSize='13.5px' fontWeight='700' color='editorialInk3'>-</Text>}
    >
      <Flex alignItems='center' gap='6px'>
        <Bookmark width={11} height={14} fill='var(--colors-editorial-accent-deep)' stroke='var(--colors-editorial-accent-deep)' />
        <Text fontSize='13.5px' fontWeight='700' color='editorialAccentDeep'>PHQ {score()}</Text>
      </Flex>
    </Show>
  )
}
